import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import BookingLookupService from "../services/BookingLookupService";
import BookingReceipt, { Card } from "./BookingReceipt";
import Spinner from "./Spinner";

// "Mina bokningar": there are no customer accounts, so the receipt is looked
// up with booking number + the email used at booking. The booking number can
// be prefilled via the ?bokningsnummer= query parameter (used by the
// confirmation page's button).
const MyBookings = () => {
    const location = useLocation();
    const prefill = new URLSearchParams(location.search).get('bokningsnummer') || '';

    const [bookingNo, setBookingNo] = useState(prefill);
    const [email, setEmail] = useState('');
    const [searching, setSearching] = useState(false);
    const [booking, setBooking] = useState(null);
    const [message, setMessage] = useState(null);

    const onSubmit = async e => {
        e.preventDefault();
        setSearching(true);
        setBooking(null);
        setMessage(null);

        try {
            const result = await BookingLookupService.lookup(bookingNo.trim(), email.trim());
            setBooking(result.booking);
        } catch (err) {
            if (err.response && (err.response.status === 404 || err.response.status === 422)) {
                setMessage('Vi hittade ingen bokning med det bokningsnumret och den e-postadressen. Kontrollera uppgifterna och försök igen.');
            } else if (err.response && err.response.status === 429) {
                setMessage('För många försök. Vänta en stund och försök igen.');
            } else {
                setMessage('Något gick fel. Försök igen om en stund.');
            }
        } finally {
            setSearching(false);
        }
    };

    return (
        <Card>
            <h3 className="text-center text-base font-semibold text-indigo-600 tracking-wide uppercase">Mina bokningar</h3>
            <p className="mt-2 text-center text-sm text-gray-500">
                Fyll i ditt bokningsnummer och e-postadressen du bokade med, så visar vi ditt kvitto.
                Bokningsnumret finns i bekräftelsemailet.
            </p>

            <form onSubmit={onSubmit} className="mt-6 max-w-md mx-auto">
                <div>
                    <label htmlFor="booking-no" className="block text-sm font-medium text-gray-700">Bokningsnummer</label>
                    <input
                        id="booking-no"
                        type="text"
                        value={bookingNo}
                        onChange={e => setBookingNo(e.target.value)}
                        required
                        autoComplete="off"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm uppercase"
                        placeholder="T.ex. AB12CD34"
                    />
                </div>
                <div className="mt-4">
                    <label htmlFor="lookup-email" className="block text-sm font-medium text-gray-700">E-postadress</label>
                    <input
                        id="lookup-email"
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        placeholder="namn@example.com"
                    />
                </div>
                <button
                    type="submit"
                    disabled={searching}
                    className="mt-6 w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 disabled:bg-gray-400"
                >
                    {searching ? <Spinner /> : 'Visa min bokning'}
                </button>
            </form>

            <div aria-live="polite" className="mt-8">
                {message && (
                    <div className="max-w-md mx-auto p-3 bg-yellow-50 border border-yellow-200 rounded-md text-sm text-yellow-800">
                        {message}
                    </div>
                )}
                {booking && <BookingReceipt booking={booking} />}
            </div>
        </Card>
    );
};

export default MyBookings;
